import React, { useRef } from 'react'
import { useMouse } from 'react-use' //useMotion
// import { Link } from 'gatsby'
import cn from 'classnames'

import s from './styles.module.scss'

type Props = {
  layer: JSX.Element[]
  width?: string
  height?: string
  speed?: number
  forceX?: number
  forceY?: number
  maxX?: number
  maxY?: number
  startOffset?: number
  disabled?: boolean
  relativeSp?: boolean
}

const Shift: React.FC<Props & React.HTMLAttributes<HTMLDivElement>> = ({
  layer,
  width,
  height,
  className,
  speed = 0.5,
  forceX = 0.1,
  forceY = 0.05,
  maxX = 500,
  maxY = 500,
  startOffset = 1,
  disabled,
  relativeSp,
}) => {
  const values = useRef({
    x: 0,
    y: 0,
    fx: forceX / layer.length,
    fy: forceY / layer.length,
  })

  const ref = useRef(null)
  const { docX, docY, posX, posY, elX, elY, elW, elH } = useMouse(ref)
  // console.log(docX, docY, posX, posY, elX, elY, elW, elH)

  // const motion = useMotion()
  // console.log(motion)

  if (!disabled) {
    let _x = elX - elW * 0.5
    let _y = elY

    _x = maxX < _x ? maxX : -maxX > _x ? -maxX : _x
    _y = maxY < _y ? maxY : -maxY > _y ? -maxY : _y

    // if (motion.acceleration.x !== null && motion.acceleration.y !== null) {
    //   _x = motion.acceleration.x
    //   _y = motion.acceleration.y
    // }

    values.current.x = _x
    values.current.y = _y
  }

  const { x, y, fx, fy } = values.current

  return (
    <div
      className={cn(s.shift, { [s.relativeSp]: relativeSp }, className)}
      ref={ref}
      style={{
        width,
        height,
      }}
    >
      {layer
        .slice()
        .reverse()
        .map((el, index) => (
          <div
            key={index}
            className={s.layer}
            style={{
              transform: `translate(${x * (index + startOffset) * fx}px, ${
                y * (index + startOffset) * fy
              }px)`,
              transitionDuration: `${speed}s`,
            }}
          >
            {el}
          </div>
        ))}
    </div>
  )
}

export default Shift
